import { IProductListAsMutate } from 'services/queryClient/wrapperHooks/product/useProductListAsMutate';

import alb from '../alb';
import api from '../api';

export interface IProduto {
	id: number;
	nome_produto: string;
	codigo_produto: string;
}
export const getProducts = async ({
	queryKey,
}): Promise<{ data: IProduto[]; count: number }> => {
	const [, familia_id, produto_id, status, page, size] = queryKey;
	const filters: any[] = [
		{
			column_name: 'familia_id',
			value_type: 'number',
			values: familia_id,
			operation: 'equal',
		},
	];
	if (produto_id) {
		filters.push({
			column_name: 'id',
			value_type: 'number',
			values: produto_id,
			operation: 'equal',
			prioritario: true,
		});
	}
	if (status !== undefined) {
		filters.push({
			column_name: 'status',
			value_type: 'booleano',
			values: true,
			operation: 'equal',
		});
	}
	const result = await api.post('/produto/view', {
		filters,
		pagination: {
			page: +page || 0,
			size: +size || 100,
		},
	});
	return result.data;
};
export const getProductsByFiltersAndLimit = async ({
	notProductIds,
	familyId,
	productId,
	status,
	participa_rateio,
	...others
}: IProductListAsMutate) => {
	const response = await api.get('/produto/filtroProduto', {
		params: {
			id: productId,
			familia_id: familyId,
			status,
			ignore_produto_id: notProductIds,
			participa_rateio,
			...others,
		},
	});

	return response.data;
};

export const getProductsByFiltersAndLimitPage = async payload => {
	const response = await api.get('/produto/filtroProduto/paginado', {
		params: { ...payload },
	});

	return response.data;
};

export const getOrcamentos = () => {
	return api.get('/orcamento?empresa_id=1');
};

export const getTicketMedio = () => {
	return api.get('/ticketMedio');
};

export const createProduct = async body => {
	const response = await api.post('/produto', body);
	return response.data;
};

export const getFamiliesWithProducts = async ({ queryKey }) => {
	const [, produtos_status, produtos_participa_rateio] = queryKey;
	const response = await alb.get('/family', {
		params: {
			produtos_status,
			produtos_participa_rateio,
		},
	});
	return response.data;
};

export const getFamiliesByFilters = async ({ queryKey }) => {
	const [, produtos_status, produtos_participa_rateio] = queryKey;
	const response = await api.get('/family', {
		params: {
			produtos_status,
			produtos_participa_rateio,
		},
	});
	return response.data;
};

export const getAllFamilies = async ({ queryKey }) => {
	const response = await api.get('/family/all');
	return response.data;
};

export const getFamiliesByFiltersAndLimit = async (
	produtos_status?: boolean,
	produtos_participa_rateio?: boolean,
	busca?: string,
	limit?: number,
	orderBy?: string,
	sort?: string
) => {
	const response = await api.get('/family', {
		params: {
			produtos_status,
			produtos_participa_rateio,
			busca,
			limit,
			orderBy,
			sort,
		},
	});
	return response.data;
};

export const getFamiliesByFiltersAndLimitPage = async ({ ...paylaod }) => {
	const response = await api.get('/family/paginado', {
		params: { ...paylaod },
	});
	return response.data;
};

export const getSubFamiliesByFiltersAndLimit = async (
	busca?: string,
	limit?: number,
	orderBy?: string,
	sort?: string
) => {
	const response = await api.get('/subfamily', {
		params: {
			busca,
			limit,
			orderBy,
			sort,
		},
	});
	return response.data;
};

export const getSubFamiliesByFiltersAndLimitPage = async paylaod => {
	const response = await api.get('/subfamily/paginado', {
		params: { ...paylaod },
	});
	return response.data;
};

export const uploadPortfolio = async body => {
	const response = await api.post('/bulkCreate/order-backlog', body);

	return response.data;
};

export const uploadBudget = async body => {
	const response = await api.post(
		'/arquivoExcelOrcamentos/uploadArquivoOrcamento',
		body
	);

	return response.data;
};

export const uploadForecast = async body => {
	// Analisar progresso de upload, funcional apenas em redes mais lentas
	const response = await api.post(
		'/arquivoExcelForecastDemandas/uploadArquivoForecastDemanda',
		body
	);

	return response.data;
};

export const getSales = () => {
	return api.get('/venda');
};

export const createSale = async body => {
	const response = await api.post('/venda', body);
	return response.data;
};

export const createBudget = async body => {
	const response = await api.post('/orcamento', body);
	return response.data;
};
export const getMembers = ({ queryKey }) => {
	const [, filterBySalesChannel, salesChannelId] = queryKey;

	let url = `/membro`;

	if (filterBySalesChannel && salesChannelId) {
		url = `/membro?filter_by_canal_venda=${filterBySalesChannel}&canal_venda_id=${salesChannelId}`;
	} else if (filterBySalesChannel === false && salesChannelId) {
		url = `/membro?filter_by_canal_venda=${filterBySalesChannel}&canal_venda_id=${salesChannelId}`;
	}

	return api.get(url);
};

export const createMember = async body => {
	const response = await api.post('/membro', body);
	return response.data;
};

export const getSalesZone = () => {
	const response = api.get('/zonaVenda');
	return response;
};

export const createSalesZone = async body => {
	const response = await api.post('/zonaVenda', body);
	return response.data;
};

export const getSalesForce = () => {
	const response = api.get('/forcaVenda');
	return response;
};

export const createSalesChannel = async body => {
	const response = await api.post('/canalvenda', body);
	return response.data;
};

export const createSalesForce = async body => {
	const response = await api.post('/forcaVenda', body);
	return response.data;
};

export const getCompanyArea = () => {
	const response = api.get('/areaEmpresa');
	return response;
};
export const getRelatedCustomers = async () => {
	const response = await api.get('/clienteRelacionado');
	return response.data;
};

export const createRelated = async body => {
	const response = await api.post('/clienteRelacionado', body);
	return response.data;
};

export const createRelatedCustomer = async (body, id) => {
	const url = `/clienteRelacionado?id=${id}`;
	const response = await api.patch(url, body);
	return response.data;
};
export const updateSubFamily = async (body, id) => {
	const response = await api.patch(`/subfamily?id=${id}`, {
		nome_sub_familia: body.nome,
	});
	return response.data;
};

export const deleteFamily = async (id: string | number) => {
	const response = await api.delete(`/family?id=${id}`);
	return response.data;
};

export const deleteFamilyByFilters = async (filters: any) => {
	const response = await api.post('family/delete-by-filters', filters);
	return response.data;
};

//Colaboração
export const getCollaboration = async () => {
	const response = await api.get('/colaboracao/list');
	return response.data;
};

export const exportCollaboration = async () => {
	const response = await api.get('/colaboracao/exportaCSV');
	return response.data;
};

export const exportConsensus = async ({ queryKey }) => {
	const [, cycleId] = queryKey;

	const url = `/consenso/exportaCSV?ciclo_id=${cycleId}`;
	const response = await api.get(url);
	return response.data;
};

export const deleteSubFamily = async (id: string | number) => {
	const response = await api.delete(`/subfamily?id=${id}`);
	return response.data;
};

export const deleteSubFamilyByFilters = async (filters: any) => {
	const response = await api.post('subfamily/delete-by-filters', filters);
	return response.data;
};

export const getHierarquia = () => {
	return api.get('/hierarquia');
};

export const getMarkets = () => {
	return api.get('/mercado');
};

export const createMarket = async body => {
	const response = await api.post('/mercado', body);
	return response.data;
};

export const getProductNotFamily = async () => {
	const response = await api.get('/produto/produtoSemFamilia');
	return response.data;
};
//Update
export const pathProduct = async (query, product) => {
	const response = await api.patch(`/produto?id=${query.id}`, product);
	return response.data;
};

export const getStates = async () => {
	const response = await api.get('/estado');
	return response.data;
};
